import PageContentContainer from "../../Container/PageContentContainer";
import CaseFileGenerateForm from "../../CaseFileGenerate/CaseFileGenerateForm";
import CasePdfGenerator from "../../Case/CasePdfGenerator/CasePdfGenerator";
import CaseNotFound from "../../Case/CaseNotFound/CaseNotFound";
import { ProductHeadline } from "../../PageHeadline/PageHeadline";
import { useCase } from "../../../provider/CaseProvider";
import LegalBirdPageLoading from "../../ContentLoader/LegalBirdPageLoading";
import NavigationExtensionCaseFileGenerate from "../../NavigationBar/NavigationExtensionCaseFileGenerate";
import { generatableFilesAndAttachments } from "../../../services/generatableFilesService";
import ButtonLoading from "../../Button/ButtonLoading";
import React from "react";
import LegalbirdTipTapEditorProvider from "../../LbEditor/LegalbirdTipTapEditorProvider";
import _ from "lodash";
import { saveSessionStorageState } from "../../../services/browserStorageService";
import { Editor } from "@tiptap/react";
import { getEditorHtml } from "../../../services/Editor/editorFunctions";

import { ProductUnion } from "../../../types/ProductUnion";
import { useRegisterRefetchPageData } from "../../../hooks/useRegisterRefetchPageData.ts";
import { ResponseError } from "../../../services/ApiClient";

const CaseFileGeneratePage = () => {
  const { product, isLoading, error, refreshCase } = useCase();

  useRegisterRefetchPageData(refreshCase);

  if (isLoading) {
    return <LegalBirdPageLoading />;
  }

  if ((error instanceof ResponseError && error.status === 404) || product?.customer?.isFake) {
    return <CaseNotFound />;
  }

  if (!product) {
    return null;
  }

  const caseFileAttachmentGenerateCfg = {
    scrollToAnchor: "contractFilesAttachment",
    title: "Schriftsatz und Anlagen",
    postUrl: "filesAndAttachment/generate/",
    helperText: "Art der Datei: z.B. Klageschrift, Replik",
    submitButton: ({
      isLoading,
      product,
      disabled,
    }: {
      isLoading: boolean;
      product: ProductUnion;
      disabled: boolean;
    }) => (
      <ButtonLoading
        sx={{ width: "350px" }}
        isLoading={isLoading}
        disabled={disabled || !product.responsibleLawyer || isLoading}
        type={"submit"}
        color={"primary"}
        variant={"contained"}
      >
        Dokument mit Anlagen generieren
      </ButtonLoading>
    ),
    getAvailableDocuments: generatableFilesAndAttachments,
  };

  return (
    <>
      <NavigationExtensionCaseFileGenerate product={product} />
      <PageContentContainer size={"small"}>
        <ProductHeadline title="Schriftsatz erstellen für" product={product} />
        <CaseFileGenerateForm product={product} />
        <CaseFileGenerateForm product={product} componentCfg={caseFileAttachmentGenerateCfg} />
        <LegalbirdTipTapEditorProvider
          placeholder={"Freitext"}
          onUpdate={_.debounce(({ editor }: { editor: Editor }) => {
            saveSessionStorageState("customPdfHtml" + product.id, getEditorHtml(editor));
          }, 3000)}
          defaultAlignment={"justify"}
        >
          <CasePdfGenerator product={product} />
        </LegalbirdTipTapEditorProvider>
      </PageContentContainer>
    </>
  );
};

export default CaseFileGeneratePage;
